export const DataType = {
  CONTACT: 'CONTACT',
  COMPANY: 'COMPANY',
  INVOICE: 'INVOICE',
  JOB_CARD: 'JOB_CARD',
  ORDER: 'ORDER',
  OPPORTUNITY: 'OPPORTUNITY',
  PART: 'PART',
  PURCHASE_INVOICE: 'PURCHASE_INVOICE',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  DELIVERY: 'DELIVERY',
}
